import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { LessonContext } from '../BookChapter/LessonContext'
import LessonToolbar from '../LessonStudent/LessonToolbar'
import BookPaper from '../Common/BookPaper/BookPaper'
import LessonHomeworkHeader from '../Common/LessonHomeworkHeader/LessonHomeworkHeader'
import Exercise from '../Common/Exercise/Exercise'
import WithoutExercises from '../Common/WithoutExercises/WithoutExercises'
import st from '../LessonStudent/LessonStudent.module.scss'
import lessonStudentStore from '../LessonStudent/lessonStudentStore'
import { observer } from 'mobx-react'
import useLocalization from '../../../../hooks/useLocalization'

const StudentFavorites = () => {
  const { id } = useParams()
  const { fetchStudentFavorites, lesson } = lessonStudentStore
  const context = { mode: 'student' }

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'exercises',
    dict: {
      save_answer: 'Save Answer',
      didnt_answer_task: 'You didn’t answer all the tasks in the exercise',
      favorites_are_empty: 'Favorites are empty',
      favorites_empty_descr:
        'You have not yet added any exercises to your favorites. After adding exercises to your favorites, you can always find them on this page and return to their repetition',
      favorites: 'Favorites',
      add_to_favorites: 'Add to Favorites',
      dislike: 'Dislike',
      dont_forget: "Don't forget to save your answer",
    },
  })
  useEffect(() => {
    fetchStudentFavorites(id)
  }, [fetchStudentFavorites, id])

  return lesson ? (
    <div className={st.lessonStudent}>
      <LessonToolbar withoutButtons />
      <div className={st.bookContainer}>
        <BookPaper>
          <div className={st.bookColumn}>
            <LessonHomeworkHeader
              title={translate.favorites}
              ebookName={lesson.ebook_name}
            />
            {lesson.exercises.length > 0 ? (
              <LessonContext.Provider value={context}>
                {lesson.exercises?.map((ex, index) => (
                  <Exercise
                    translate={translate}
                    key={ex.id}
                    number={`1.${index + 1}`}
                    ex={ex}
                  />
                ))}
              </LessonContext.Provider>
            ) : (
              <WithoutExercises
                text1={`${translate.favorites_are_empty} :(`}
                text2={translate.favorites_empty_descr}
              />
            )}
          </div>
        </BookPaper>
      </div>
    </div>
  ) : null
}

export default observer(StudentFavorites)
